// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"5b137d36","727":"0346acbd"}[chunkId] + ".chunk.js";
};